<template>
  <div
    class="card-brand-badge"
    :class="{ 'card-brand-badge_outlined': brandInfo.outlined }"
    :style="{ backgroundColor: brandInfo.color, color: brandInfo.logoColor }"
  >
    <font-awesome-icon
      v-if="brandInfo.brandIcon"
      class="card-brand-badge__logo"
      :icon="['fab', brandInfo.brandIcon]"
    />
    <img
      v-else-if="brandInfo.image"
      class="card-brand-badge__image"
      :style="brandInfo.imageStyle"
      :src="brandInfo.image"
      :alt="brandInfo.label"
    />
    <v-icon
      v-else-if="brandInfo.icon"
      color="white"
      size="22"
    >
      {{ brandInfo.icon }}
    </v-icon>
    <span v-else>{{ brandInfo.label }}</span>
  </div>
</template>

<script>
  const BRANDS = {
    // Знак «Мира» вытянутый: во всю ширину смотрится тяжело, чуть ужимаем
    mir: { label: 'МИР', image: '/icons/cards/mir.svg', color: '#0F754E', imageStyle: { width: '80%' } },
    // logoColor — когда плашка светлая и белый знак Font Awesome на ней не читается
    visa: { label: 'Visa', image: '/icons/cards/visa.svg', color: '#fff', outlined: true, imageStyle: { width: '80%' } },
    mastercard: { label: 'Mastercard', image: '/icons/cards/mastercard.svg', color: '#231F20', imageStyle: { width: '62%' } },
    amex: { label: 'American Express', image: '/icons/cards/amex.svg', color: '#016FD0', imageStyle: { objectFit: 'cover' } },
    americanexpress: { label: 'American Express', image: '/icons/cards/amex.svg', color: '#016FD0', imageStyle: { objectFit: 'cover' } },
    jcb: { label: 'JCB', image: '/icons/cards/jcb.svg', color: '#fff', outlined: true, imageStyle: { width: '62%' } },
    dinersclub: { label: 'Diners Club', image: '/icons/cards/diners-club.svg', color: '#fff', outlined: true, imageStyle: { width: '86%' } },
    discovercard: { label: 'Discover', image: '/icons/cards/discover.svg', color: '#fff', outlined: true, imageStyle: { width: '86%' } },
    maestro: { label: 'Maestro', image: '/icons/cards/maestro.svg', color: '#231F20', imageStyle: { width: '62%' } },
    unionpay: { label: 'UnionPay', image: '/icons/cards/unionpay.svg', color: '#fff', outlined: true, imageStyle: { width: '62%' } },
  }

  const FALLBACK = { icon: 'mdi-credit-card-outline', color: '#9E9E9E' }

  export default {
    name: 'CardBrandBadge',
    props: {
      brand: {
        type: String,
        default: null,
      },
    },
    computed: {
      brandInfo () {
        const key = (this.brand || '').toLowerCase().replace(/\s+/g, '')
        return BRANDS[key] || FALLBACK
      },
    },
  }
</script>

<style scoped lang="less">
.card-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 48px;
  padding: 4px;
  border-radius: 6px;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;

  // Светлая плашка на белой карточке сливается — очерчиваем
  &_outlined {
    border: 1px solid #dbdfe6;
  }

  // Логотип занимает плашку целиком, пропорции держит сам SVG
  &__logo,
  &__image {
    width: 100%;
    height: 100%;
  }
}
</style>
